export default "__VITE_ASSET__ByjsoccG__"